export enum ValidationEventTypes {
  Error,
  Warning,
  Info,
  Success,
}
